module.exports = __webpack_public_path__ + "static/media/undraw_tasks.e66c35ad.svg";